/**
 * External Dependencies
 */
import React from "react";
import "./styles.scss";
import SignInForm from "blocks/signin-form";
import { ButtonV2 } from "../../../components/button-v2";
import logo from "../../../assets/images/logo_color.png";
import { Text } from "../../../components/text";
import { useEurekaLogin } from "../../../utils/eureka";

const SiteLogin = () => {
  const [eurekaRedirecting, setEurekaRedirecting] = React.useState(false);
  const { login: loginWithEureka } = useEurekaLogin();
  const talinkEnabled = process.env.REACT_APP_TALINK_LOGIN_ENABLED === 'true';

  const logoMarkup = (
    <div className="flex flex-col items-center mb-6 gap-2">
      <img src={logo} alt="Logo" style={{ height: 48, width: "auto" }} />
      <div
        className="bg-white rounded-full px-2 py-0.5"
        style={{ border: "1px solid #d1d5db" }}
      >
        <Text
          tone="subdued"
          variant="bodyXs"
        >{`v${process.env.REACT_APP_VERSION}`}</Text>
      </div>
    </div>
  );

  const footerMarkup = (
    <div
      className="fixed bottom-0 left-0 right-0 flex justify-between items-center px-4 py-1.5 bg-gray-100"
      style={{ borderTop: "1px solid #d1d5db" }}
    >
      <Text tone="subdued" variant="bodyXs">{`© ${new Date().getFullYear()} Tower Systems Pty Ltd · Visual Deck`}</Text>
      <Text tone="subdued" variant="bodyXs">{`v${process.env.REACT_APP_VERSION}`}</Text>
    </div>
  );

  if (eurekaRedirecting) {
    return (
      <div className="flex justify-center items-center h-full bg-gray-100 p-4 pb-16">
        <div className="w-full" style={{ maxWidth: 450 }}>
          {logoMarkup}
          <Text variant="bodySm" alignment="center">
            You will be redirected to the Eureka portal to sign in shortly.
          </Text>
        </div>
        {footerMarkup}
      </div>
    );
  }

  return (
    <div className="flex flex-col justify-center items-center h-full bg-gray-100 p-4 pb-16">
      <div className="w-full" style={{ maxWidth: 450 }}>
        {logoMarkup}
        {talinkEnabled && (
          <>
            <SignInForm />
            <div className="flex items-center gap-3 my-8">
              <div style={{ flex: 1, height: 1, backgroundColor: "#d1d5db" }} />
              <Text tone="subdued" variant="bodySm">
                or
              </Text>
              <div style={{ flex: 1, height: 1, backgroundColor: "#d1d5db" }} />
            </div>
          </>
        )}
        <ButtonV2
          size="xl"
          fullWidth
          variant="outline"
          filled={false}
          onClick={() => {
            setEurekaRedirecting(true);
            loginWithEureka();
          }}
        >
          Tower Advantage™ Login
        </ButtonV2>
      </div>
      {footerMarkup}
    </div>
  );
};

export default SiteLogin;
